import { useCallback, useState } from 'react';

export const useClipPlayerThumbnail = ({ showThumbnailOnMount }: { showThumbnailOnMount: boolean }) => {
  const [showThumbnailImage, setShowThumbnailImage] = useState(showThumbnailOnMount);

  const removeThumbnailImage = useCallback(() => {
    setShowThumbnailImage(false);
  }, []);

  return {
    showThumbnailImage,
    removeThumbnailImage
  };
};
